export default __webpack_public_path__ + "static/media/more-detail-img.139f6c34.svg";